<template>
    <v-row>
        <v-col v-if="stateRichmenu" cols="1" class="pr-0 pt-0 mb-2">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openMenu('menu')" icon v-bind="attrs" v-on="on" :disabled="statemember !== 'active'">
                        <v-icon color="white lighten-1">
                            fas fa-list
                        </v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('ChatSide.menu') }}</span>
            </v-tooltip>
        </v-col>
        <v-col cols="1" v-for="(item, index) in list_menu" :key="index" class="pr-0 pt-0 mb-2">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openMenu(item.id)" icon v-bind="attrs" v-on="on" :disabled="statemember !== 'active'">
                        <v-icon color="white lighten-1">
                            {{ item.icon }}
                        </v-icon>
                    </v-btn>
                </template>
                <span>{{ item.text }}</span>
            </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="1" class="pr-0 pt-0 mb-2">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openMenu('sticker')" icon v-bind="attrs" v-on="on" :disabled="statemember !== 'active'">
                        <v-icon color="white lighten-1">
                            fa-solid fa-face-grin-wide
                        </v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('ChatSide.sticker') }}</span>
            </v-tooltip>
        </v-col>
				<div style="display:none;">
            <input multiple type="file" id="image" @change="sendFileAndImage($event, 'image')" accept="image/*" />
            <input multiple type="file" id="file" @change="sendFileAndImage($event, 'file')" />
        </div>
    </v-row>
</template>
<script>
export default {
    props: {
        statemember: String,
        stateRichmenu: Boolean
    },
    data() {
        return {
            list_menu: [],
        }
    },
    created() {
        // console.log("statemember =>", this.statemember);
        this.list_menu = [
            { text: this.$t('ChatSide.image'), icon: 'far fa-file-image', id: 'image' },
            { text: this.$t('ChatSide.file'), icon: 'fa-solid fa-paperclip', id: 'file' },
            { text: this.$t('ChatSide.friend'), icon: 'fa-solid fa-user', id: 'friend' },
            { text: this.$t('ChatSide.location'), icon: 'fa-solid fa-location-dot', id: 'location' },
        ]
    },
		methods: {
			openMenu(id) {
				// console.log("openMenu => ", id);
                if (id === 'friend' || id === 'location' || id === 'sticker' || id === 'menu') {
                    this.$emit('emitChatMenu', { type: id, item: '' })
                } else {
                    document.getElementById(id).click()
                }
			},
			sendFileAndImage (event, type) {
				// console.log(event.target.files);
				this.$emit('emitChatMenu', { type: type, item: event })
				document.getElementById(type).value = ''
				document.getElementById(type).value = ''
			},
		},
}
</script>
<style scoped></style>